import { Button, ButtonSize, Spin } from 'lego-on-react';
import React from 'react';

import block from 'propmods';

import './AddLanguage.scss';

interface AddLanguageProps {
    text: string;
    inProgress?: boolean;
    disabled?: boolean;
    size?: ButtonSize;
    onClick: () => void;
}

const bs = block('AddLanguage');

export default function AddLanguage(props: AddLanguageProps) {
    const { text, inProgress = false, disabled = false, size = 'm', onClick } = props;
    return (
        <div {...bs()}>
            <Button theme="action" size={size} disabled={disabled || inProgress} onClick={onClick}>
                {text}
            </Button>
            {inProgress && <Spin size="s" progress />}
        </div>
    );
}
